import studentExchangeService from '@/shared/services/domain/studentExchange'
import axios, { AxiosStatic } from 'axios'

const services = ($axios: AxiosStatic) => ({
    studentExchange: studentExchangeService($axios),
})

export default services(axios)
